window.checkCart = function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const checkoutButton = document.querySelector('[checkout-data-terms-action]');
      if (!checkoutButton) return;

      if (cart.items.length === 1 && cart.items[0].variant_id === 49503753797952) {
        checkoutButton.setAttribute('disabled', 'disabled');
      } else {
        checkoutButton.removeAttribute('disabled');
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
};

document.addEventListener("DOMContentLoaded", function() {

  // Function to get a cookie by name
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

  // Function to set a cookie
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
  
if (document.getElementById("countdown-timer")) {

    // Default duration in hours, minutes, and seconds (e.g., 3 hours)
    const defaultDuration = "03:00:00";

    // Function to get the current time from the cookie or use the default duration
    function getCountdownTime() {
      const savedTime = getCookie('countdown_time');
      if (savedTime) {
        return new Date(savedTime);
      }
      // If no cookie, set the countdown time to the default duration
      const futureTime = new Date();
      const [hours, minutes, seconds] = defaultDuration.split(':');
      futureTime.setHours(futureTime.getHours() + parseInt(hours));
      futureTime.setMinutes(futureTime.getMinutes() + parseInt(minutes));
      futureTime.setSeconds(futureTime.getSeconds() + parseInt(seconds));

      // Save the future time in the cookie
      setCookie('countdown_time', futureTime.toString(), 3); // expires in 3 days (you can adjust)

      return futureTime;
    }

    // Function to format the time to always display two digits
    function padZero(number) {
      return number < 10 ? '0' + number : number;
    }

    // Function to update the countdown timer
    function updateCountdown() {
      const endTime = getCountdownTime();
      const now = new Date();
      const timeRemaining = endTime - now;

      if (timeRemaining <= 0) {
        // Reset countdown after time has ended
        setCookie('countdown_time', '', -1); // Remove the cookie
        document.getElementById("countdown-timer").innerHTML = "Time's up!";
        return;
      }

      const hours = padZero(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      const minutes = padZero(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)));
      const seconds = padZero(Math.floor((timeRemaining % (1000 * 60)) / 1000));

      document.getElementById("countdown-timer").innerHTML = `${hours}h: ${minutes}m: ${seconds}s`;
    }

    // Update the countdown every second
    setInterval(updateCountdown, 1000);
  }


  //--------------- PDP People Bought----------------
        const randomNumber = Math.floor(Math.random() * (900 - 5 + 1)) + 5;
        const peopleBoughtElement = document.querySelector(".people_bought_main");
    
        if (peopleBoughtElement) {
          const pdp_id = peopleBoughtElement.getAttribute('product_id');
          const cookieName = `people_bought_${pdp_id}`;
          const cookieValue = getCookie(cookieName);
    
          if (cookieValue) {
            peopleBoughtElement.querySelector(".people_bought_random").innerHTML = `${cookieValue}`;
            peopleBoughtElement.style.display = 'flex';
          } else {
            peopleBoughtElement.querySelector(".people_bought_random").innerHTML = `${randomNumber}`;
            setCookie(cookieName, randomNumber, 1);
            peopleBoughtElement.style.display = 'flex';
          }
        }

   $(".pdp-accordion-header").click(function(){
        $('.pdp-accordion-header').removeClass('active_item');
        if ($(this).next(".pdp-accordion-content").is(":hidden")) {
          $(this).addClass('active_item');
        }
        $(this).next(".pdp-accordion-content").slideToggle("fast");
        $(".pdp-accordion-content").not($(this).next()).slideUp("fast");
      });

  $('.m-product-option--node input[type="radio"]').on('change',function(){
    var select_value = $(this).val();
    console.log(select_value);
    if(select_value == '20 ml'){
      $('.custom-engraving-option').hide();
      const engraving_input = document.querySelector('.engraving_input');
      if (engraving_input) {
        engraving_input.remove();
      }
    }else{
      $('.custom-engraving-option').show();
    }
  });

  // Function to show toast notification
      function showToast(message) {
        const toast = document.createElement('div');
        toast.classList.add('toast_new');
        toast.textContent = message;
    
        $('.main-product__block-variant_picker').append(toast);
        setTimeout(() => {
          toast.remove();
        }, 2000);
      }
      $(".as-uff-pd-offer img").click(function(){
        showToast('Auto Applied!');
      });

  //---------- Default 50ml Select -----------------
      var getOption = setInterval(function() {
        var option = $('variant-button input[value="50 ml"]:not(:checked)');
        var option_2 = $('variant-button input[value="50 ml × 2"]:not(:checked)');
          if (option.length > 0) {
              option.click();
              clearInterval(getOption);
          }
          if (option_2.length > 0) {
              option_2.click();
              clearInterval(getOption);
          }
      }, 100);
      setTimeout(function() {
          clearInterval(getOption);
      }, 60000);

  if (window.checkCart()) {window.checkCart();}

  // var checkReview = setInterval(function() {
  //   if ($('.ultimate-perfume-box-containder .custom-vstar-rating-widget').length > 0) {
  //     var stop_interval = false;
  //     $('.upb-product-item').each(function() {
  //       var $widget = $(this);
  //       var $iconList = $widget.find('.product-icon-list');
  //       if ($iconList.length > 0){
  //         var rating = parseFloat($iconList.attr('rating'));
  //         var review_num = $iconList.attr('data-review-num');
  //         $widget.find('.rating_count').text(rating);
  //         $widget.find('.review_num').text(review_num || '0');
  //         $widget.find('.custom_ratings').css('opacity', '1'); 
  //         stop_interval = true;
  //       }
  //     });
      
  //     if(stop_interval){
  //        clearInterval(checkReview); 
  //     }
  //   }
  // }, 1000);

  //   setTimeout(function(){
  //     clearInterval(checkReview);
  //   },30000);
  
});
